export const upIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="10" fill="none" stroke="var(--dark-brown-color)" strokeWidth="2" />
            <path fill="var(--dark-brown-color)" d="M12 8l-4 4h3v4h2v-4h3z" />
        </svg>
    );
};